import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberResearchProjects } from "./routeType";

const { key, getPath } = getApi("members.researchProject.getAll");

type IExtractedRouteType =
  IMemberResearchProjects["researchProjectCollectionRetrieve"];

export type IGetAllMemberResearchProjects =
  IPickCollectionQuery<IExtractedRouteType>;

const getAllMemberResearchProjects: Fetcher<
  IGetAllMemberResearchProjects["response"],
  IGetAllMemberResearchProjects["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetAllMemberResearchProjects = createQuery({
  queryKey: [key],
  fetcher: getAllMemberResearchProjects,
});
